export default __webpack_public_path__ + "static/media/beatboy5.e896b268.gif";